module.exports = __webpack_public_path__ + "static/devdocs-6e20016b04a33a792bb331047f909ca4.png";